import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PartnerScorecardFacade } from './partner-scorecard.facade';
import { DashboardPageDefinition } from '../../dashboard.data';
import { DashboardVmState } from '../../domain/model/dashboard-vm.model';
import { PartnerScorecardVm, ScorecardChart, ScorecardChartVm } from '../../domain/model/partner-scorecard.model';

/** Partner scorecard page: six trailing-month bar charts and the declined reasons, for the selected scope. */
@Component({
  selector: 'ifbp-partner-scorecard',
  templateUrl: './partner-scorecard.component.html',
  styleUrls: ['./partner-scorecard.component.scss'],
  providers: [PartnerScorecardFacade],
  standalone: false,
})
export class PartnerScorecardComponent implements OnInit {
  page$: Observable<DashboardPageDefinition>;
  vm$: Observable<PartnerScorecardVm>;
  readonly VmState = DashboardVmState;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly facade: PartnerScorecardFacade,
  ) {}

  ngOnInit(): void {
    this.page$ = this.route.data.pipe(map((data: Data) => data.dashboardPage as DashboardPageDefinition));
    this.vm$ = this.facade.vm$;
  }

  /** The six month cards are fixed and distinct; their chart key is the stable key. */
  trackByChart(_index: number, chart: ScorecardChartVm): ScorecardChart {
    return chart.chart;
  }
}
